import { render } from "./cronologiaStati.vue?vue&type=template&id=136a2d17&ts=true"
import script from "./cronologiaStati.vue?vue&type=script&lang=ts"
export * from "./cronologiaStati.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__